// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu[data-v-88ca09d4]{border-top-left-radius:40px;border-top-right-radius:40px;background-color:#fff;color:#4f3f3e;padding:10px}.menu-bar[data-v-88ca09d4]{padding:2px 0 12px 0;display:flex;align-items:center}.bar[data-v-88ca09d4]{margin:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
